import React from 'react'
import { Link } from 'react-router-dom';
import { Button } from '../Button';
import "./Footer.css";

function Footer() {
    return (
        <div className="footer-container">
            <section className="footer-subscription">
                <p className="footer-subscription-heading">
                    Join the Advanture newsletter to receive our best vacation deals
                </p>
                <p className="footer-subscripton-text">
                    You can unsubscribe any time.
                </p>
                <div className="input-areas">
                    <form action="">
                        <input type="email" name="email" placeholder="You Email" className="footer-input"/>
                        <Button buttonStyle="btn--outline">Subscribe</Button>
                    </form>
                </div>
            </section>
            <div className="footer-links">
                <div className="footer-links-wrapper">
                    <div className="footer-links-items">
                        <h2>About Us</h2>
                        <Link to="/sign-up">How it Works</Link>
                        <Link to="/">Testimonials</Link>
                        <Link to="/">Careers</Link>
                        <Link to="/">Investors</Link>
                        <Link to="/">Terms of Services</Link>
                    </div>
                    <div className="footer-links-items">
                        <h2>Contact Us</h2>
                        <Link to="/sign-up">How it Works</Link>
                        <Link to="/">Testimonials</Link>
                        <Link to="/">Careers</Link>
                        <Link to="/">Investors</Link>
                        <Link to="/">Terms of Services</Link>
                    </div>
                    <div className="footer-links-items">
                        <h2>About Us</h2>
                        <Link to="/sign-up">How it Works</Link>
                        <Link to="/">Testimonials</Link>
                        <Link to="/">Careers</Link>
                        <Link to="/">Investors</Link>
                        <Link to="/">Terms of Services</Link>
                    </div>
                    <div className="footer-links-items">
                        <h2>Contact Us</h2>
                        <Link to="/sign-up">How it Works</Link>
                        <Link to="/">Testimonials</Link>
                        <Link to="/">Careers</Link>
                        <Link to="/">Investors</Link>
                        <Link to="/">Terms of Services</Link>
                    </div>
                </div>
                <div className="footer-links-wrapper">
                    <div className="footer-links-items">
                        <h2>Services</h2>
                        <Link to="/sign-up">How it Works</Link>
                        <Link to="/">Testimonials</Link>
                        <Link to="/">Careers</Link>
                        <Link to="/">Investors</Link>
                        <Link to="/">Terms of Services</Link>
                    </div>
                    <div className="footer-links-items">
                        <h2>Links</h2>
                        <Link to="/sign-up">How it Works</Link>
                        <Link to="/">Testimonials</Link>
                        <Link to="/">Careers</Link>
                        <Link to="/">Investors</Link>
                        <Link to="/">Terms of Services</Link>
                    </div>
                    <div className="footer-links-items">
                        <h2>Links</h2>
                        <Link to="/sign-up">How it Works</Link>
                        <Link to="/">Testimonials</Link>
                        <Link to="/">Careers</Link>
                        <Link to="/">Investors</Link>
                        <Link to="/">Terms of Services</Link>
                    </div>
                    <div className="footer-links-items">
                        <h2>Links</h2>
                        <Link to="/sign-up">How it Works</Link>
                        <Link to="/">Testimonials</Link>
                        <Link to="/">Careers</Link>
                        <Link to="/">Investors</Link>
                        <Link to="/">Terms of Services</Link>
                    </div>
                </div>
            </div>
            <section className="social-media">
                <div className="social-media-wrap">
                    <div className="fotr-logo">
                        <Link className="social-logo">SunRiser</Link>
                </div>
                <small className="website-rights">SunRiser C 2021</small>
                <div className="social-icons">
                    <Link className="social-icons-link facebook"
                    to="/" target="_blank" aria-label="Facebook">
                        <i className="fab fa-facebook-f"></i>
                    </Link>
                    <Link className="social-icons-link youtube"
                    to="/" target="_blank" aria-label="YouTube">
                        <i className="fab fa-youtube"></i>
                    </Link>
                    <Link className="social-icons-link twitter"
                    to="/" target="_blank" aria-label="Twitter">
                        <i className="fab fa-twitter"></i>
                    </Link>
                    <Link className="social-icons-link dribbble"
                    to="/" target="_blank" aria-label="dribble">
                        <i className="fab fa-dribbble"></i>
                    </Link>
                </div>
                </div>
            </section>
        </div>
    )
}

export default Footer;
